import stringReplacer from './string';
export default function (_, mods, value) {
    return stringReplacer('s', mods, (value ? 'true' : 'false'));
}
